var map = {
	"./activity.svg": [
		"8dd6",
		"chunk-2d0e9974"
	],
	"./agent.svg": [
		"7394",
		"chunk-2d0d67ed"
	],
	"./airplay.svg": [
		"3240",
		"chunk-2d0b9211"
	],
	"./alert-circle.svg": [
		"1ec1",
		"chunk-2d0b6e78"
	],
	"./alert-octagon.svg": [
		"e165",
		"chunk-2d224921"
	],
	"./alert-triangle.svg": [
		"836d",
		"chunk-2d0ddc1f"
	],
	"./align-center.svg": [
		"86d7",
		"chunk-2d0decc7"
	],
	"./align-justify.svg": [
		"e45d",
		"chunk-2d225474"
	],
	"./align-left.svg": [
		"d4aa",
		"chunk-2d21e566"
	],
	"./align-right.svg": [
		"7526",
		"chunk-2d0d6e98"
	],
	"./analytics.svg": [
		"f412",
		"chunk-2d22c825"
	],
	"./anchor.svg": [
		"8652",
		"chunk-2d0de711"
	],
	"./announcement-speaker.svg": [
		"e927",
		"chunk-2d2266af"
	],
	"./aperture.svg": [
		"71e2",
		"chunk-2d0d65bd"
	],
	"./archive.svg": [
		"8238",
		"chunk-2d0dd7d5"
	],
	"./arrow-down-circle.svg": [
		"32cb",
		"chunk-2d0b97f4"
	],
	"./arrow-down-left.svg": [
		"eb08",
		"chunk-2d23005b"
	],
	"./arrow-down-right.svg": [
		"5f8e",
		"chunk-2d0d3eb4"
	],
	"./arrow-down.svg": [
		"c874",
		"chunk-2d217ac8"
	],
	"./arrow-left-circle.svg": [
		"cbf7",
		"chunk-2d221e26"
	],
	"./arrow-left.svg": [
		"ac3b",
		"chunk-2d213327"
	],
	"./arrow-right-circle.svg": [
		"70be",
		"chunk-2d0d61d2"
	],
	"./arrow-right.svg": [
		"cd8c",
		"chunk-2d222042"
	],
	"./arrow-up-circle.svg": [
		"c88e",
		"chunk-2d217b18"
	],
	"./arrow-up-left.svg": [
		"320c",
		"chunk-2d0b91c8"
	],
	"./arrow-up-right.svg": [
		"b137",
		"chunk-2d20eba9"
	],
	"./arrow-up.svg": [
		"a3f8",
		"chunk-2d2084fa"
	],
	"./asset.svg": [
		"a04a",
		"chunk-2d2073d2"
	],
	"./asterisk.svg": [
		"b68a",
		"chunk-2d20ff33"
	],
	"./at-sign.svg": [
		"c1aa",
		"chunk-2d2165c4"
	],
	"./australia.svg": [
		"7c0b",
		"chunk-2d0e1b34"
	],
	"./award.svg": [
		"d815",
		"chunk-2d21ee6e"
	],
	"./bar-chart-2.svg": [
		"054d",
		"chunk-2d0a406b"
	],
	"./bar-chart.svg": [
		"bde4",
		"chunk-2d21b127"
	],
	"./battery-charging.svg": [
		"cc3c",
		"chunk-2d221be6"
	],
	"./battery.svg": [
		"e74d",
		"chunk-2d225f98"
	],
	"./bluetooth.svg": [
		"1565",
		"chunk-2d0ab4d9"
	],
	"./bold.svg": [
		"ff26",
		"chunk-2d2383fa"
	],
	"./book-open.svg": [
		"4679",
		"chunk-2d0c15da"
	],
	"./book.svg": [
		"fc4e",
		"chunk-2d237924"
	],
	"./bookmark.svg": [
		"7253",
		"chunk-2d0d63af"
	],
	"./box.svg": [
		"bb19",
		"chunk-2d21a35e"
	],
	"./briefcase.svg": [
		"24c90",
		"chunk-745a3302"
	],
	"./building.svg": [
		"a528",
		"chunk-2d208630"
	],
	"./cake.svg": [
		"c7cc",
		"chunk-2d217c8a"
	],
	"./calendar.svg": [
		"b8bd",
		"chunk-2d210bce"
	],
	"./camera-off.svg": [
		"c45f",
		"chunk-2d216bb8"
	],
	"./camera.svg": [
		"24e5",
		"chunk-2d0b2b28"
	],
	"./canada.svg": [
		"b876",
		"chunk-2d21066b"
	],
	"./caret-down.svg": [
		"3f24",
		"chunk-2d0c550b"
	],
	"./caret-left.svg": [
		"eee7",
		"chunk-2d231208"
	],
	"./caret-right.svg": [
		"138f",
		"chunk-2d0aadc6"
	],
	"./caret-up.svg": [
		"2d60",
		"chunk-2d0bd9a2"
	],
	"./cast.svg": [
		"18b4",
		"chunk-2d0ac56f"
	],
	"./categories-of-data.svg": [
		"2462",
		"chunk-2d0b2574"
	],
	"./chart-points.svg": [
		"0d71",
		"chunk-2d0af104"
	],
	"./check-circle.svg": [
		"cfcb",
		"chunk-2d222cf8"
	],
	"./check-square.svg": [
		"7367",
		"chunk-2d0d6793"
	],
	"./check.svg": [
		"7bae",
		"chunk-2d0e1d65"
	],
	"./chevron-double-left.svg": [
		"c288",
		"chunk-2d216465"
	],
	"./chevron-down.svg": [
		"1755",
		"chunk-2d0abc3c"
	],
	"./chevron-left.svg": [
		"d0fe",
		"chunk-2d21d701"
	],
	"./chevron-right.svg": [
		"88ee",
		"chunk-2d0df496"
	],
	"./chevron-up.svg": [
		"bb5d",
		"chunk-2d21a405"
	],
	"./chevrons-down.svg": [
		"36a4",
		"chunk-2d0ba68c"
	],
	"./chevrons-left.svg": [
		"d836",
		"chunk-2d21eead"
	],
	"./chevrons-right.svg": [
		"04a9",
		"chunk-2d0a41f2"
	],
	"./chevrons-up.svg": [
		"98a7",
		"chunk-2d0e684b"
	],
	"./chrome.svg": [
		"b5dd",
		"chunk-2d2100c9"
	],
	"./circle-check-full.svg": [
		"5aa3",
		"chunk-2d0d30b4"
	],
	"./circle-question-mark.svg": [
		"ed8a",
		"chunk-2d2308fe"
	],
	"./circle-radio-deselected.svg": [
		"b2d0",
		"chunk-2d20f552"
	],
	"./circle-radio-selected-solid.svg": [
		"f4e4",
		"chunk-2d22ce73"
	],
	"./circle.svg": [
		"b289",
		"chunk-2d20f007"
	],
	"./clipboard-full.svg": [
		"f5a2",
		"chunk-2d22d1b6"
	],
	"./clipboard.svg": [
		"4247",
		"chunk-2d0c0677"
	],
	"./clock-history.svg": [
		"69cb",
		"chunk-2d0d0f58"
	],
	"./clock.svg": [
		"755b",
		"chunk-2d0d6f21"
	],
	"./cloud-drizzle.svg": [
		"59f4",
		"chunk-2d0c9b28"
	],
	"./cloud-lightning.svg": [
		"79ac",
		"chunk-2d0d837a"
	],
	"./cloud-off.svg": [
		"c864",
		"chunk-2d217aa9"
	],
	"./cloud-rain.svg": [
		"f383",
		"chunk-2d22c53e"
	],
	"./cloud-snow.svg": [
		"13d6",
		"chunk-2d0ab2ea"
	],
	"./cloud.svg": [
		"2b35",
		"chunk-2d0bd1c8"
	],
	"./code-alt-script.svg": [
		"4fcb",
		"chunk-2d0ccf87"
	],
	"./code.svg": [
		"100a",
		"chunk-2d0aa186"
	],
	"./codepen.svg": [
		"133b",
		"chunk-2d0aad27"
	],
	"./collaboration.svg": [
		"d67c",
		"chunk-2d21e7d4"
	],
	"./color-picker.svg": [
		"635b",
		"chunk-2d0cf340"
	],
	"./command.svg": [
		"870e",
		"chunk-2d0dea6a"
	],
	"./compass.svg": [
		"7259",
		"chunk-2d0d63b5"
	],
	"./controllers.svg": [
		"21c6",
		"chunk-2d0b1fa8"
	],
	"./copy.svg": [
		"8aac",
		"chunk-2d0e8e01"
	],
	"./corner-down-left.svg": [
		"2b96",
		"chunk-2d0bd283"
	],
	"./corner-down-right.svg": [
		"a13d",
		"chunk-2d207777"
	],
	"./corner-left-down.svg": [
		"2078",
		"chunk-2d0b1695"
	],
	"./corner-left-up.svg": [
		"e12a",
		"chunk-2d2248d1"
	],
	"./corner-right-down.svg": [
		"97a1",
		"chunk-2d0e6484"
	],
	"./corner-right-up.svg": [
		"bbb0",
		"chunk-2d21a944"
	],
	"./corner-up-left.svg": [
		"c86b",
		"chunk-2d217ad7"
	],
	"./corner-up-right.svg": [
		"cd1a",
		"chunk-2d221f67"
	],
	"./cpu.svg": [
		"2769",
		"chunk-2d0b30be"
	],
	"./credit-card-alt.svg": [
		"cb9e",
		"chunk-2d2218e1"
	],
	"./credit-card.svg": [
		"98dc",
		"chunk-2d0e68d4"
	],
	"./crop.svg": [
		"2269",
		"chunk-2d0b1df9"
	],
	"./crosshair.svg": [
		"468c",
		"chunk-2d0c1623"
	],
	"./dai-candidate.svg": [
		"0563",
		"chunk-2d0a4078"
	],
	"./dai-contractor.svg": [
		"d576",
		"chunk-2d21e3e6"
	],
	"./dai-customer.svg": [
		"f096",
		"chunk-2d22ba1d"
	],
	"./dai-employee.svg": [
		"8e20",
		"chunk-2d0e9721"
	],
	"./dai-other.svg": [
		"a7b8",
		"chunk-2d209382"
	],
	"./dai-prospect.svg": [
		"a980",
		"chunk-2d2095e6"
	],
	"./dai-subscriber.svg": [
		"240c",
		"chunk-2d0b24eb"
	],
	"./dashboard-governance.svg": [
		"2885",
		"chunk-2d0b34b9"
	],
	"./dashboard.svg": [
		"ecef",
		"chunk-2d230ab5"
	],
	"./data-types.svg": [
		"a796",
		"chunk-2d208e89"
	],
	"./database.svg": [
		"fad5",
		"chunk-2d237742"
	],
	"./delete.svg": [
		"0d45",
		"chunk-2d0af0ab"
	],
	"./dialpad.svg": [
		"09ed",
		"chunk-2d0a555e"
	],
	"./disc.svg": [
		"b448",
		"chunk-2d20f70c"
	],
	"./dollar-sign.svg": [
		"c18f",
		"chunk-2d2160d2"
	],
	"./dot.svg": [
		"6a22",
		"chunk-2d0d9f61"
	],
	"./download-cloud.svg": [
		"de7d",
		"chunk-2d229844"
	],
	"./download.svg": [
		"f28e",
		"chunk-2d22c1af"
	],
	"./droplet.svg": [
		"2003",
		"chunk-2d0b15b7"
	],
	"./edit-2.svg": [
		"72c9",
		"chunk-2d0d6947"
	],
	"./edit-3.svg": [
		"61e8",
		"chunk-2d0cf164"
	],
	"./edit.svg": [
		"daf0",
		"chunk-2d228ebd"
	],
	"./endpoint.svg": [
		"cce0",
		"chunk-2d2221c1"
	],
	"./envelope-alt.svg": [
		"7379",
		"chunk-2d0d67b4"
	],
	"./envelope.svg": [
		"8e29",
		"chunk-2d0e972a"
	],
	"./external-link.svg": [
		"b64a",
		"chunk-2d20feb7"
	],
	"./eye-off.svg": [
		"8ff8",
		"chunk-2d0ea136"
	],
	"./eye.svg": [
		"7364",
		"chunk-2d0d6790"
	],
	"./facebook.svg": [
		"8485",
		"chunk-2d0ddfef"
	],
	"./fast-forward.svg": [
		"60df",
		"chunk-2d0cedb2"
	],
	"./feather.svg": [
		"75bf",
		"chunk-2d0d7498"
	],
	"./file-minus.svg": [
		"ca38",
		"chunk-2d221439"
	],
	"./file-plus.svg": [
		"1f05",
		"chunk-2d0b6c10"
	],
	"./file-text.svg": [
		"aac1",
		"chunk-2d213144"
	],
	"./file.svg": [
		"a147",
		"chunk-2d207769"
	],
	"./film.svg": [
		"0750",
		"chunk-2d0a47d8"
	],
	"./filter.svg": [
		"2376",
		"chunk-2d0b21d6"
	],
	"./flag.svg": [
		"c26e",
		"chunk-2d216454"
	],
	"./folder-minus.svg": [
		"a509",
		"chunk-2d2085f3"
	],
	"./folder-plus.svg": [
		"c62f",
		"chunk-2d2172dd"
	],
	"./folder.svg": [
		"383d",
		"chunk-2d0ba8ac"
	],
	"./folders.svg": [
		"791e",
		"chunk-2d0d7dac"
	],
	"./fullscreen.svg": [
		"379e",
		"chunk-2d0ba5a6"
	],
	"./gift.svg": [
		"fb5c",
		"chunk-2d237580"
	],
	"./git-branch.svg": [
		"942e",
		"chunk-2d0e53c4"
	],
	"./git-commit.svg": [
		"fa9a",
		"chunk-2d237239"
	],
	"./git-merge.svg": [
		"2cc9",
		"chunk-2d0bdb5d"
	],
	"./git-pull-request.svg": [
		"ef50",
		"chunk-2d230ff2"
	],
	"./github.svg": [
		"14f6",
		"chunk-2d0ab6e9"
	],
	"./gitlab.svg": [
		"1a58",
		"chunk-2d0b59e9"
	],
	"./globe.svg": [
		"0de3",
		"chunk-2d0af698"
	],
	"./grid.svg": [
		"4b05",
		"chunk-2d0cba29"
	],
	"./hard-drive.svg": [
		"66af",
		"chunk-2d0d03db"
	],
	"./hash.svg": [
		"8316",
		"chunk-2d0ddb56"
	],
	"./headphones.svg": [
		"1f3e",
		"chunk-2d0b6c9d"
	],
	"./heart.svg": [
		"7d16",
		"chunk-2d0e1ee8"
	],
	"./help-circle.svg": [
		"a530",
		"chunk-2d208647"
	],
	"./home.svg": [
		"ac9d",
		"chunk-2d2133e3"
	],
	"./idea-light-bulb.svg": [
		"02c4",
		"chunk-2d0a3aa9"
	],
	"./image.svg": [
		"931c",
		"chunk-2d0e4fe2"
	],
	"./inbox.svg": [
		"2a9f",
		"chunk-2d0bcef2"
	],
	"./info.svg": [
		"76ed",
		"chunk-2d0d78b4"
	],
	"./instagram.svg": [
		"bd6c",
		"chunk-2d21aba5"
	],
	"./instructions.svg": [
		"ed7f",
		"chunk-2d2308e4"
	],
	"./intercom.svg": [
		"5b30",
		"chunk-2d0d2ee0"
	],
	"./italic.svg": [
		"9944",
		"chunk-2d0e6696"
	],
	"./key.svg": [
		"daf4",
		"chunk-2d228ec1"
	],
	"./layers.svg": [
		"626a",
		"chunk-2d0cef9d"
	],
	"./layout.svg": [
		"be29",
		"chunk-2d21aec0"
	],
	"./license.svg": [
		"f001",
		"chunk-2d22b901"
	],
	"./life-buoy-help.svg": [
		"b464",
		"chunk-2d20f746"
	],
	"./link-2.svg": [
		"aaa2",
		"chunk-2d213107"
	],
	"./link-broken.svg": [
		"b76f",
		"chunk-2d2102bb"
	],
	"./link.svg": [
		"40a1",
		"chunk-2d0c0462"
	],
	"./linkedin.svg": [
		"9ed9",
		"chunk-2d0f1197"
	],
	"./list.svg": [
		"99ad",
		"chunk-2d0e6c39"
	],
	"./live-support-agent-headset.svg": [
		"d8f3",
		"chunk-2d21f4d7"
	],
	"./loader.svg": [
		"04ff",
		"chunk-2d0a42ba"
	],
	"./lock.svg": [
		"9619",
		"chunk-2d0e5afb"
	],
	"./log-in.svg": [
		"815f",
		"chunk-2d0dd480"
	],
	"./log-out-alt.svg": [
		"defe",
		"chunk-2d229df6"
	],
	"./log-out.svg": [
		"3367",
		"chunk-2d0b9617"
	],
	"./map-pin.svg": [
		"60c5",
		"chunk-2d0ced62"
	],
	"./map.svg": [
		"0443",
		"chunk-2d0a3c79"
	],
	"./maximize-2.svg": [
		"3d18",
		"chunk-2d0c4d6e"
	],
	"./maximize.svg": [
		"f098",
		"chunk-2d22ba1f"
	],
	"./menu.svg": [
		"d17f",
		"chunk-2d21d512"
	],
	"./message-circle.svg": [
		"6c61",
		"chunk-2d0da75e"
	],
	"./message-square.svg": [
		"3a6e",
		"chunk-2d0c42f3"
	],
	"./mic-off.svg": [
		"17cd",
		"chunk-2d0ac1fd"
	],
	"./mic.svg": [
		"6366",
		"chunk-2d0cf333"
	],
	"./minimize-2.svg": [
		"29cc",
		"chunk-2d0b3ddd"
	],
	"./minimize.svg": [
		"6b30",
		"chunk-2d0da33f"
	],
	"./minus-circle.svg": [
		"4ade",
		"chunk-2d0cbce4"
	],
	"./minus-square.svg": [
		"63a0",
		"chunk-2d0cf862"
	],
	"./minus.svg": [
		"3e24",
		"chunk-2d0c514a"
	],
	"./monitor.svg": [
		"2477",
		"chunk-2d0b2598"
	],
	"./moon.svg": [
		"0190",
		"chunk-2d0a31ce"
	],
	"./more-horizontal.svg": [
		"6988",
		"chunk-2d0d09f9"
	],
	"./more-vertical.svg": [
		"144d",
		"chunk-2d0ab109"
	],
	"./move.svg": [
		"d8c1",
		"chunk-2d21f478"
	],
	"./music.svg": [
		"65ad",
		"chunk-2d0d0018"
	],
	"./navigation-2.svg": [
		"784b",
		"chunk-2d0d7a45"
	],
	"./navigation-alt.svg": [
		"7f9b",
		"chunk-2d0e278e"
	],
	"./navigation.svg": [
		"dc25",
		"chunk-2d228ff8"
	],
	"./notification-bell-off.svg": [
		"107d",
		"chunk-2d0aa262"
	],
	"./notification-bell.svg": [
		"7499",
		"chunk-2d0d6bb3"
	],
	"./octagon.svg": [
		"f0d9",
		"chunk-2d22bf55"
	],
	"./package.svg": [
		"d07a",
		"chunk-2d21d14c"
	],
	"./paperclip.svg": [
		"b308",
		"chunk-2d20f2cf"
	],
	"./pause-circle.svg": [
		"40a9",
		"chunk-2d0c046a"
	],
	"./pause.svg": [
		"644b",
		"chunk-2d0cf6e2"
	],
	"./percent.svg": [
		"58c8",
		"chunk-2d0c970e"
	],
	"./phone-call.svg": [
		"c251",
		"chunk-2d216401"
	],
	"./phone-chat-message-sms.svg": [
		"4317",
		"chunk-2d0c09db"
	],
	"./phone-filled.svg": [
		"cc55",
		"chunk-2d221bf6"
	],
	"./phone-forwarded.svg": [
		"127f",
		"chunk-2d0aa9e6"
	],
	"./phone-incoming-2.svg": [
		"b330",
		"chunk-2d20f324"
	],
	"./phone-missed.svg": [
		"2e11",
		"chunk-2d0bdcc9"
	],
	"./phone-off.svg": [
		"d81e",
		"chunk-2d21ee9e"
	],
	"./phone-outgoing.svg": [
		"9391",
		"chunk-2d0e50a8"
	],
	"./phone.svg": [
		"c3bb",
		"chunk-2d216d66"
	],
	"./pie-chart.svg": [
		"9773",
		"chunk-2d0e5f70"
	],
	"./pin-alt.svg": [
		"d3f1",
		"chunk-2d21e210"
	],
	"./play-circle.svg": [
		"1708",
		"chunk-2d0abba4"
	],
	"./play.svg": [
		"dab1",
		"chunk-2d228e42"
	],
	"./playbooks.svg": [
		"7618",
		"chunk-2d0d723c"
	],
	"./plug.svg": [
		"1758",
		"chunk-2d0abc3f"
	],
	"./plus-circle.svg": [
		"d99e",
		"chunk-2d21f357"
	],
	"./plus-square.svg": [
		"0156",
		"chunk-2d0a3158"
	],
	"./plus.svg": [
		"eb38",
		"chunk-2d2300b8"
	],
	"./pocket.svg": [
		"1f3e9",
		"chunk-7462273c"
	],
	"./policies.svg": [
		"4c6e",
		"chunk-2d0cbed4"
	],
	"./power.svg": [
		"111a",
		"chunk-2d0aa566"
	],
	"./printer.svg": [
		"345d",
		"chunk-2d0b99e6"
	],
	"./processors.svg": [
		"30ce",
		"chunk-2d0b9075"
	],
	"./radio.svg": [
		"c473",
		"chunk-2d216bc3"
	],
	"./refresh-ccw.svg": [
		"5e59",
		"chunk-2d0d3a6a"
	],
	"./refresh-cw.svg": [
		"697c",
		"chunk-2d0d0a05"
	],
	"./regex.svg": [
		"45f2",
		"chunk-2d0c17c3"
	],
	"./repeat.svg": [
		"c015",
		"chunk-2d215c07"
	],
	"./responsible-party.svg": [
		"a828",
		"chunk-2d209173"
	],
	"./rewind.svg": [
		"7f1d",
		"chunk-2d0e2698"
	],
	"./rotate-ccw.svg": [
		"8f7f",
		"chunk-2d0e9bb3"
	],
	"./rotate-cw.svg": [
		"44ea",
		"chunk-2d0c1412"
	],
	"./rss.svg": [
		"0fe5",
		"chunk-2d0afe1c"
	],
	"./save.svg": [
		"9344",
		"chunk-2d0e5010"
	],
	"./scan.svg": [
		"a4c5",
		"chunk-2d20885b"
	],
	"./scissors.svg": [
		"0aeb",
		"chunk-2d0aeb84"
	],
	"./screen-with-search.svg": [
		"ac5d",
		"chunk-2d213367"
	],
	"./search-text.svg": [
		"444c",
		"chunk-2d0c0e25"
	],
	"./search.svg": [
		"d103",
		"chunk-2d21d406"
	],
	"./send.svg": [
		"5b6e",
		"chunk-2d0d2f72"
	],
	"./sensitive-data-scan.svg": [
		"d687",
		"chunk-2d21e7c7"
	],
	"./sensitive-data-watcher.svg": [
		"d505",
		"chunk-2d21e30c"
	],
	"./server.svg": [
		"90f6",
		"chunk-2d0e4add"
	],
	"./settings-admin.svg": [
		"682a",
		"chunk-2d0d05a7"
	],
	"./settings.svg": [
		"9174",
		"chunk-2d0e48eb"
	],
	"./share-2.svg": [
		"93a5",
		"chunk-2d0e5584"
	],
	"./share.svg": [
		"bd5b",
		"chunk-2d21ab85"
	],
	"./shield-off.svg": [
		"dc04",
		"chunk-2d228fb9"
	],
	"./shield-person.svg": [
		"4961",
		"chunk-2d0c20f6"
	],
	"./shield.svg": [
		"64fe",
		"chunk-2d0cfcf3"
	],
	"./shopping-bag.svg": [
		"38f3",
		"chunk-2d0baea8"
	],
	"./shopping-cart.svg": [
		"b15e",
		"chunk-2d20ec15"
	],
	"./shuffle.svg": [
		"00e6",
		"chunk-2d0a3367"
	],
	"./sidebar.svg": [
		"f0e9",
		"chunk-2d22bf74"
	],
	"./skip-back.svg": [
		"4474",
		"chunk-2d0c0e53"
	],
	"./skip-forward.svg": [
		"90e34",
		"chunk-74bb0cd9"
	],
	"./slack.svg": [
		"4c73",
		"chunk-2d0cbec1"
	],
	"./slash.svg": [
		"7ca8",
		"chunk-2d0e20f9"
	],
	"./sliders.svg": [
		"ff3f",
		"chunk-2d238449"
	],
	"./smartphone.svg": [
		"4008",
		"chunk-2d0bfe7a"
	],
	"./speaker.svg": [
		"5989",
		"chunk-2d0c959b"
	],
	"./sphere.svg": [
		"15e0",
		"chunk-2d0aba85"
	],
	"./spirion-logo.svg": [
		"d6b3",
		"chunk-2d21ecd9"
	],
	"./square-checkbox-solid.svg": [
		"b577",
		"chunk-2d20fb29"
	],
	"./square.svg": [
		"d8a7",
		"chunk-2d21f440"
	],
	"./star.svg": [
		"cc90",
		"chunk-2d221c6d"
	],
	"./status.svg": [
		"c10e",
		"chunk-2d215fd9"
	],
	"./stop-circle.svg": [
		"b448c",
		"chunk-76fdead7"
	],
	"./sun.svg": [
		"3961",
		"chunk-2d0bac97"
	],
	"./sunrise.svg": [
		"ff5e",
		"chunk-2d238486"
	],
	"./sunset.svg": [
		"8dd61",
		"chunk-74c4953d"
	],
	"./tablet.svg": [
		"a9e0",
		"chunk-2d209b59"
	],
	"./tag-filled.svg": [
		"2d94",
		"chunk-2d0bda03"
	],
	"./tag.svg": [
		"81fd",
		"chunk-2d0dda6d"
	],
	"./target.svg": [
		"0129",
		"chunk-2d0a30fe"
	],
	"./terminal.svg": [
		"e7bd",
		"chunk-2d22652a"
	],
	"./thermometer.svg": [
		"5bcf",
		"chunk-2d0d34e6"
	],
	"./thumbs-down.svg": [
		"9a65",
		"chunk-2d0efcfd"
	],
	"./thumbs-up.svg": [
		"fe9c",
		"chunk-2d23813f"
	],
	"./toggle-left.svg": [
		"6d4a",
		"chunk-2d0dab11"
	],
	"./toggle-right.svg": [
		"943d",
		"chunk-2d0e53e2"
	],
	"./trash-2.svg": [
		"5a1e",
		"chunk-2d0d2b16"
	],
	"./trash.svg": [
		"af22",
		"chunk-2d213e1b"
	],
	"./tree.svg": [
		"0ff9",
		"chunk-2d0afe3f"
	],
	"./trending-down.svg": [
		"33f5",
		"chunk-2d0b9be5"
	],
	"./trending-up.svg": [
		"6d65",
		"chunk-2d0dab23"
	],
	"./triangle.svg": [
		"a8fe",
		"chunk-2d2097ec"
	],
	"./truck.svg": [
		"e5ca",
		"chunk-2d225dc4"
	],
	"./tv.svg": [
		"e678",
		"chunk-2d225c08"
	],
	"./twitter.svg": [
		"acf9",
		"chunk-2d21392b"
	],
	"./type.svg": [
		"fa90",
		"chunk-2d237208"
	],
	"./uk.svg": [
		"47dd",
		"chunk-2d0c1f39"
	],
	"./umbrella.svg": [
		"b53e",
		"chunk-2d20fadb"
	],
	"./underline.svg": [
		"f893",
		"chunk-2d22d822"
	],
	"./unlock.svg": [
		"d901",
		"chunk-2d21f20c"
	],
	"./upload-cloud.svg": [
		"1c9c",
		"chunk-2d0b6212"
	],
	"./upload.svg": [
		"5a96",
		"chunk-2d0d2bdf"
	],
	"./user-avatar-alt.svg": [
		"b7ae",
		"chunk-2d2107ef"
	],
	"./user-bubble.svg": [
		"1957",
		"chunk-2d0ac3c0"
	],
	"./user-check.svg": [
		"8fcf",
		"chunk-2d0ea107"
	],
	"./user-data.svg": [
		"26ce",
		"chunk-2d0b329c"
	],
	"./user-default-avatar.svg": [
		"140f",
		"chunk-2d0ab08f"
	],
	"./user-exclamation.svg": [
		"cf73",
		"chunk-2d222775"
	],
	"./user-minus.svg": [
		"1f00",
		"chunk-2d0b6c0b"
	],
	"./user-plus.svg": [
		"9c31",
		"chunk-2d0f041e"
	],
	"./user-x.svg": [
		"0ed2",
		"chunk-2d0afa39"
	],
	"./user.svg": [
		"6aed",
		"chunk-2d0da5c0"
	],
	"./users.svg": [
		"d956",
		"chunk-2d21f2ac"
	],
	"./vendor.svg": [
		"74ec",
		"chunk-2d0d7131"
	],
	"./video-off.svg": [
		"e243",
		"chunk-2d224ca2"
	],
	"./video.svg": [
		"512b",
		"chunk-2d0c7702"
	],
	"./voicemail.svg": [
		"f045",
		"chunk-2d22b981"
	],
	"./volume-1.svg": [
		"16a4",
		"chunk-2d0abdce"
	],
	"./volume-2.svg": [
		"dcea",
		"chunk-2d229651"
	],
	"./volume-x.svg": [
		"4d0b",
		"chunk-2d0cc1d8"
	],
	"./volume.svg": [
		"8901",
		"chunk-2d0df1b8"
	],
	"./watch.svg": [
		"bacc",
		"chunk-2d21a5d5"
	],
	"./wifi-off.svg": [
		"9177",
		"chunk-2d0e48ee"
	],
	"./wifi.svg": [
		"4351",
		"chunk-2d0c0a51"
	],
	"./wind.svg": [
		"079d",
		"chunk-2d0a4888"
	],
	"./woman.svg": [
		"48dc",
		"chunk-2d0c22f9"
	],
	"./x-circle.svg": [
		"2940",
		"chunk-2d0b37f9"
	],
	"./x-square.svg": [
		"1004",
		"chunk-2d0aa159"
	],
	"./x.svg": [
		"7387",
		"chunk-2d0d67d1"
	],
	"./youtube.svg": [
		"11ef",
		"chunk-2d0aabb7"
	],
	"./zap-off.svg": [
		"a8fd",
		"chunk-2d2097eb"
	],
	"./zap.svg": [
		"f5ce",
		"chunk-2d22d227"
	],
	"./zoom-in.svg": [
		"d3ec",
		"chunk-2d21e223"
	],
	"./zoom-out.svg": [
		"3063",
		"chunk-2d0b8ad0"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "153d";
module.exports = webpackAsyncContext;